import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import type { IWorkspace } from "app/services/workspaces/workspaceApi.types";

import * as ac from "./action-creators";

export type CommonState = {
    workspaces: IWorkspace[];
    isRightBarOpen: boolean;
    widgetIdRightBar: string | undefined;
};

const INITIAL_COMMON_STATE: CommonState = {
    workspaces: [],
    isRightBarOpen: false,
    widgetIdRightBar: undefined,
};

const commonReducer = createReducer<CommonState, ActionType<typeof ac>>(INITIAL_COMMON_STATE)
    .handleAction(ac.setWorkspacesListAction, (state, { payload }) => ({
        ...state,
        workspaces: payload,
    }))
    .handleAction(ac.toggleRightBar, (state, { payload }) => ({
        ...state,
        isRightBarOpen: payload,
    }))
    .handleAction(ac.setWidgetIdRightBar, (state, { payload }) => ({
        ...state,
        widgetIdRightBar: payload,
    }));
export default commonReducer;
